import styled from "@emotion/styled";

export const Container = styled("button")`
  all: unset;
  display: flex;
  cursor: pointer;
  align-items: center;

  label {
    margin-left: 8px !important;
  }
`;
